export default __webpack_public_path__ + "static/media/add.c706a3b7.svg";